// extracted by mini-css-extract-plugin
module.exports = {"followMe":"mt","linkItem":"mu","linkItemWrap":"mv","title":"mw","linkAppItemWrap":"mx","iconWrap":"my","mfollowMe":"mz","miconWrap":"mA","followMe-dark":"mB","followMeDark":"mB"};